export const colors = {
  primary: "#938370",
  primary90: "rgba(147,131,112,0.9)",
  primary80: "rgba(147,131,112,0.8)",
  cta: "#A74C00",
  clickable_text: "#0066ff",
};
